import { render, staticRenderFns } from "./EditNum.vue?vue&type=template&id=35e45b50"
import script from "./EditNum.vue?vue&type=script&lang=js"
export * from "./EditNum.vue?vue&type=script&lang=js"
import style0 from "./EditNum.vue?vue&type=style&index=0&id=35e45b50&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports